import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './quote-button.module.scss';
import { applyClasses, applyProps } from '../shared/js';

const QuoteButtons = ({ children, ...props }) => (
  <div
    className={cn(
      styles.container,
      // eslint-disable-next-line react/prop-types
      props.className,
      applyClasses(props, styles)
    )}
    {...applyProps(props)}
  >
    {children}
  </div>
);

QuoteButtons.propTypes = {
  /** The buttons in the wrapper */
  children: PropTypes.any,
};

QuoteButtons.defaultProps = {
  children: undefined,
};

export default QuoteButtons;
